var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-777.000000, -528.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M783.5,533.25 L780.2375,533.25 C781.897584,530.698707 785.03769,529.542716 787.955771,530.408615 C790.873852,531.274515 792.875194,533.956157 792.875,537 L794.125004,537 C794.128526,533.575327 791.984305,530.516129 788.76386,529.351168 C785.543415,528.186207 781.938266,529.165633 779.75,531.8 L779.75,529.5 L778.5,529.5 L778.5,534.5 L783.5,534.5 L783.5,533.25 Z M788.5,540.75 L791.7625,540.75 C790.102416,543.301293 786.96231,544.457284 784.044229,543.591385 C781.126148,542.725485 779.124806,540.043843 779.125,537 L777.874996,537 C777.871474,540.424673 780.015695,543.483871 783.23614,544.648832 C786.456585,545.813793 790.061734,544.834367 792.25,542.2 L792.25,544.5 L793.5,544.5 L793.5,539.5 L788.5,539.5 L788.5,540.75 Z",
    id: "Fill"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.42c19b5052de6fe0a313d7e4049c39ca.svg";
export { ForwardRef as ReactComponent };